import _find from 'lodash/find'
export function getFAQs({ dataUI, context }) {
  let cheapestOffer
  try {
    if (!dataUI.magazine) {
      return null
    }

    if (dataUI?.magazine?.isNewspaper) {
      return null
    }

    if (dataUI.offers === undefined) {
      return null
    }

    if (dataUI.magazine.cheapestOfferId && (dataUI.offers.PRINT || dataUI.offers.INTERNATIONAL || dataUI.offers.SINGLE_ISSUES)) {
      const offers = dataUI.offers.PRINT || dataUI.offers.INTERNATIONAL || dataUI.offers.SINGLE_ISSUES
      cheapestOffer = offers.find(offer => offer.isDefault === true) || undefined
    }

    if (cheapestOffer === undefined) {
      return null
    }
  } catch (e) {
    console.error('getFAQMicrodataJSONLD error=', e)
    return null
  }

  const title = dataUI.magazine.title
  const price = `£${cheapestOffer.price}`
  const numOfIssuesPerYear = dataUI?.magazine?.cheapestOfferNumOfIssuesPerYear || 1
  let numOfIssuesPerYearLabel = `${numOfIssuesPerYear} issues`
  if (numOfIssuesPerYear === 1) {
    numOfIssuesPerYearLabel = '1 issue'
  }

  const cheapestOfferNumOfIssues = dataUI?.magazine?.cheapestOfferNumOfIssues || 1
  let cheapestOfferNumOfIssuesLabel = `${cheapestOfferNumOfIssues} issues`
  if (cheapestOfferNumOfIssues === 1) {
    cheapestOfferNumOfIssuesLabel = '1 issue'
  }

  const publisher = dataUI.magazine.publisher
  const faqs = [
    {
      question: `How much is ${title} magazine?`,
      answer: `${title} magazine subscriptions start from ${price} for ${cheapestOfferNumOfIssuesLabel}. Most magazines listed on magazine.co.uk offer a variety of subscription terms, including annual, half-yearly and quarterly subscriptions, alongside digital magazine subscription offers through our partner - Pocketmags.`,
      id: 1,
      isOpen: false
    },
    {
      question: `How often is ${title} magazine published?`,
      answer: `${title} magazine is published ${numOfIssuesPerYear} times per year, meaning an annual subscription will consist of ${numOfIssuesPerYearLabel} over a year.`,
      id: 2,
      isOpen: false
    },
    {
      question: `How can I buy ${title} magazine?`,
      answer: `Subscriptions to ${title} magazine can be bought right here on magazine.co.uk by either debit/credit card, PayPal, Google Pay, Apple Pay or Direct Debit. Please note Direct Debit magazine subscriptions will automatically renew until cancelled.`,
      id: 3,
      isOpen: false
    },
    {
      question: `How many issues of ${title} magazine are published each year?`,
      answer: `There are ${numOfIssuesPerYearLabel} of ${title} published each year. Subscribe today to receive the next ${numOfIssuesPerYearLabel} with an annual ${title} magazine subscription.`,
      id: 4,
      isOpen: false
    },
    {
      question: `Who publishes ${title} magazine?`,
      answer: `${title} is published by ${publisher}. ${publisher} also takes care of the fulfilment and delivery of your ${title} magazine subscription, meaning that subscribers tend to receive their copy before it hits the shops (and at a better price!).`,
      id: 5,
      isOpen: false
    },
    {
      question: `Do you offer delivery outside the UK?`,
      answer: `Many magazines listed on magazine.co.uk offer international delivery. To check whether a subscription is available for delivery outside of the UK, simply check for the ‘International Delivery’ tab further up the page - if visible, you’ll be able to select an international delivery destination. If this isn’t visible, then, unfortunately, the publisher does not offer delivery outside of the UK.`,
      id: 6,
      isOpen: false
    },
    {
      question: `What’s the difference between a debit/credit card and a Direct Debit subscription?`,
      answer: `Debit/credit card magazine subscriptions on magazine.co.uk do not renew automatically, and your upfront payment will cover a defined subscription period before lapsing. Alternatively, Direct Debit subscriptions will automatically renew after the initial subscription period (as displayed in your cart/basket and at checkout). Please note your Direct Debit agreement is always with the publisher of the magazine directly and not magazine.co.uk.`,
      id: 7,
      isOpen: false
    },
    {
      question: `Do you offer ${title} magazine gift subscriptions?`,
      answer: `Yes! Many magazine subscriptions on magazine.co.uk will list dedicated gift options along with standard subscriptions. These will be named, e.g. 12-month Gift Subscription. However, magazine.co.uk enables you to turn any magazine subscription into a gift subscription by ticking the ‘This is a gift’ tickbox when in your cart/basket. By selecting this option, you can choose a separate billing and gift recipient address.`,
      id: 8,
      isOpen: false
    }
  ]

  // It only shows on titles that have the digital subscriptions tab
  const hasDigital = dataUI?.offers?.DIGITAL || false
  if (hasDigital) {
    faqs.push({
      question: `Do you offer ${title} digital magazine subscriptions?`,
      answer: `Yes! Digital subscriptions to ${title} magazine are available through our partner, Pocketmags. Simply look for the ‘Digital Subscriptions’ tab further up the page, and you will find a green ‘SEE ALL OFFERS’ button, which will take you to Pocketmags.com and all the available digital offers and best prices.`,
      id: 9,
      isOpen: false
    })
  }

  // Instant access section
  // ONLY SHOW ON TITLES WITH INSTANT ACCESS
  const instantAccess = hasInstantAccessOffer(dataUI?.offers)
  if (instantAccess) {
    faqs.push({
      question: `What’s Instant Access?`,
      answer: `When you subscribe you will receive free, instant digital access to the latest issue at the time of your purchase (the cover shown on the product page). This allows you to enjoy the current issue of your magazine immediately whilst you await delivery of your first print edition. (Your first print edition will be the first new issue released after your print magazine subscription has been setup).`,
      id: 10,
      isOpen: false
    })
  }

  // ONLY SHOW AT CHRISTMAS - IN TOP POSITION
  const isXMAS = false // hasXMASOffer(dataUI?.offers)
  if (isXMAS) {
    faqs.unshift({
      question: `How do I order a magazine as a Christmas gift?`,
      answer: `To order a Christmas Gift, select the ‘Christmas Gift Subscription Offer’ if available, or select the offer you would like and then at the checkout, select ‘This is a Christmas gift. Deliver after Christmas’. Christmas Gift Subscriptions will start with the first issue released after Christmas.`,
      id: 0,
      isOpen: false
    })
  }

  // console.log('getFAQs faqs=', faqs)

  context.$store && context.$store.commit('UI/faqs', faqs, { root: true })
  return faqs
}

function hasInstantAccessOffer(offers) {
  if (!offers || !offers.PRINT) {
    return false
  }

  const found =
    offers.PRINT &&
    _find(offers.PRINT, function(i) {
      return i.instantAccess === true
    })
  console.log(`hasInstantAccessOffer=${found}`)
  return found || false
}

// function hasXMASOffer(offers) {
//   if (!offers || !offers.PRINT) {
//     return false
//   }

//   const found =
//     offers.PRINT &&
//     _find(offers.PRINT, function(i) {
//       return i.name.toLowerCase().includes('christmas gift') === true
//     })

//   console.log(`hasXMASOffer=${found}`)
//   return found || false
// }
